export {};
//# sourceMappingURL=IEventTelemetry.js.map